export const ButtonColors = [
  'primary',
  'secondary',
  'visuals',
  'visits',
  'leads',
  'participants',
  'games',
  'devices',
  'clients',
  'light-clients',
  'error',
  'campaigns',
  'text-normal',
  'header-link',
  'users',
  'text-additional',
  'white',
  'scenario',
  'coupons',
  'brand-blue',
] as const;

export const ButtonSizes = ['extra-large', 'large', 'medium', 'small', 'extra-small', 'default', 'full'] as const;
